// These are Bandwidth colors modified to meet accessibility requirements.
// Here primarily for reference.
export var greyscale = {
    5: '#F2F2F2',
    10: '#E6E5E6',
    15: '#DAD9D9',
    20: '#CECDCD',
    25: '#C1C0C1',
    30: '#B5B3B4',
    35: '#A9A7A8',
    40: '#9C9A9B',
    45: '#908D8F',
    50: '#848182',
    55: '#787576',
    60: '#6B686A',
    65: '#5F5B5D',
    70: '#524E50',
    75: '#474244',
    80: '#3A3538',
    85: '#2E292B',
    90: '#211C1E',
    95: '#161013',
    100: '#090306',
};
export var grey = {
    100: '#F2F2F2',
    200: '#DAD9D9',
    300: '#CECDCD',
    400: '#B5B3B4',
    500: '#908D8F',
    600: '#848182',
    700: '#787576',
    800: '#5F5B5D',
    900: '#090306',
};
export var blue = {
    50: '#E0F7FD',
    500: '#00BEF0',
    600: '#00A0CC',
    700: '#007B9B',
    800: '#004658',
};
export var darkBlue = {
    50: '#e0e9eb',
    500: '#004658',
    800: '#002F3D',
    900: '#00202D',
};
export var green = {
    50: '#E0FFF7',
    500: '#00FBB9',
    A400: '#00AA6C',
    A500: '#00774C',
    A700: '#005C44',
};
export var purple = {
    50: '#F3E8FB',
    300: '#C793EA',
    500: '#A95ADF',
    900: '#7E2ECA',
};
export var maroon = {
    300: '#93627D',
    500: '#651F45',
};
export var orange = {
    50: '#FFEDE8',
    200: '#FFB39E',
    500: '#FF673C',
    900: '#D52F00',
    A700: '#A53F0C',
};
// Our brand guidelines don't use yellow at all.
export var yellow = {
    50: '#FFF8DD',
    500: '#FFCC00',
    A700: '#665200',
};
export var darkOrange = {
    400: '#C54B0E',
    500: '#491C1C',
    A200: '#F49667',
};
export var white = '#FFFFFF'; // Primary bg, learning lab button bg
export default {
    greyscale: greyscale,
    blue: blue,
    darkBlue: darkBlue,
    green: green,
    yellow: yellow,
    purple: purple,
    maroon: maroon,
    orange: orange,
    darkOrange: darkOrange,
    white: white,
    grey: grey,
};
//# sourceMappingURL=colors.js.map